import React, { useState } from 'react';

function GaleriaFotos() {
  const [showDescription, setShowDescription] = useState(false);

  const images = [
    { src: '/imagem/dev5.jpg', desc: 'Desenvolvedor Web criando soluções inovadoras' },
  ];

  const descriptionText = `
    Com mais de 5 anos de experiência no desenvolvimento de software, tenho explorado diversas tecnologias e metodologias para criar produtos que impactam positivamente o cotidiano das pessoas.
    
    Minha jornada profissional começou como Auxiliar de Desenvolvimento Júnior no Grupo Conservo, onde aprimorei minhas habilidades em programação, desenvolvimento web e metodologias ágeis. Posteriormente, atuei como Assistente de Tecnologia Júnior na Prodemge, onde me aprofundei em linguagens como PHP, JavaScript e frameworks front-end como Bootstrap. Atualmente, como Analista de Tecnologia na Unimed-BH, tenho a oportunidade de colaborar em projetos de larga escala, aplicando práticas ágeis e contribuindo para o desenvolvimento de soluções eficientes.

    Minha formação acadêmica inclui uma graduação em Análise e Desenvolvimento de Sistemas pela Estácio, onde mergulhei no mundo da programação, e uma pós-graduação em Desenvolvimento Web, aprofundando meus conhecimentos em bancos de dados, PHP e outras tecnologias fundamentais.

    Minha trajetória não seria completa sem a busca contínua por aprendizado. Minha dedicação me levou a conquistar certificados em Estatística para Ciência de Dados, Clean Code, Análise de Dados em Python e outros, demonstrando meu comprometimento em me manter atualizado e aprimorar minhas habilidades.

    Estou sempre em busca de desafios que me permitam crescer como profissional e contribuir para o sucesso de projetos inovadores.
  `;

  const handleButtonClick = () => {
    setShowDescription(!showDescription);
  };

  return (
    <div style={styles.galeriaContainer}>
      {images.map((img, index) => (
        <div key={index} style={styles.cardWrapper}>
          <div style={styles.imageCard}>
            <img style={styles.image} src={img.src} alt={img.desc} />
            <p style={styles.description}>{img.desc}</p>
            <button style={styles.button} onClick={handleButtonClick}>
              {showDescription ? 'Fechar Descrição' : 'Saiba Mais'}
            </button>
          </div>
          {showDescription && (
            <div style={styles.descriptionText}>
              <p>{descriptionText}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

const styles = {
  galeriaContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    padding: '20px',
    flexWrap: 'wrap',
    position: 'relative',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageCard: {
    width: '250px',
    textAlign: 'center',
    background: '#fff',
    borderRadius: '10px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    padding: '15px',
    position: 'relative',
  },
  image: {
    width: '100%',
    borderRadius: '10px',
  },
  description: {
    fontSize: '14px',
    margin: '10px 0',
  },
  button: {
    background: '#ff6600',
    color: 'white',
    border: 'none',
    padding: '8px 15px',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background 0.3s',
    marginTop: '10px',
  },
  descriptionText: {
    marginTop: '10px',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '14px',
    color: '#333',
    maxWidth: '800px',
    margin: '20px auto',
  },
};

export default GaleriaFotos;
